import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../../Config";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import AddDuesModal from "../../../Components/Landlords/AddDuesModal";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import Documents from "../../../Components/Landlords/Details/Documents";
import { TenantDetailsLoading } from "../../../Components/SkeletonLoading";
import { capitalizeFirstLetter } from "../../../helpers";
import { BoxContainer, FloorTabs } from "../../../Components/Styles/PageStyles";
import {
    FaUser, FaShieldAlt,
} from "react-icons/fa";
import {
    MdOutlineTrendingDown,
    MdOutlineTrendingUp,
} from "react-icons/md";
import SideModal from "../../../Components/SideModal";
import Images from "../../../Images";
import Passbook from "../../../Components/Landlords/Details/Passbook";
import PersonalDetails from "../../../Components/Landlords/Details/PersonalDetails";
import MarkAsPaidOfflineModal from "../../../Components/Expenses/MarkAsPaidOfflineModal";
import MarkAsPaidOnlineModal from "../../../Components/Landlords/MarkAsPaidOnlineModal";
import ViewTransDetails from "../../../Components/Landlords/ViewTransDetails";
import Properties from "./Properties";

const Details = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const landlordId = location.state?.landlordId;
    const user = useSelector((state) => state.UserReducer.user);
    const [selectedData, setSelectedData] = useState("");
    const [showUploadModel, setShowUploadModel] = useState(false);
    const [isOnlineMarkPaidOpen, setIsOnlineMarkPaidOpen] = useState(false);
    const [isOfflineMarkPaidOpen, setIsOfflineMarkPaidOpen] = useState(false);
    const [isAddDuesModal, setIsAddDuesModal] = useState(false);
    const [activeStep, setActiveStep] = useState("Landlord Info");
    const [goTo, setGoto] = useState(location?.state?.tabKey || "totalDues");
    const [docs, setDocs] = useState([]);
    const [viewDetail, setViewDetail] = useState(false);
    const steps = ["Landlord Info", "Properties", "Passbook", "Documents"];

    const [landlordData, setLandlordData] = useState();
    const [transData, setTransData] = useState();
    const [propsData, setPropsData] = useState();
    const [securityData, setSecurityData] = useState();
    const [pendingData, setPendingData] = useState();
    const [summary, setSummary] = useState();
    const [expenseData, setExpenseData] = useState([]);

    const fetchFunction = async () => {
        const query = `landlordId=${landlordId}`;
        const response = await axios.get(
            `${Config.apiUrl}/landlord/client/summary?${query}`,
            {
                headers: {
                    authorization: "Bearer " + user.token,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.data === false) error = true;
        else {
            setSummary(res?.summary);
            setLandlordData(res?.landlord);
            setTransData(res?.transactions);
            setPropsData(res?.properties);
            setPendingData(res?.pendings);
            const securityData = res?.transactions.filter((tx) => tx.type === 43);
            setSecurityData(securityData);
            fetchInitData();
        }
    };

    const fetchInitData = async () => {
        const response = await axios.get(
            `${Config.apiUrl}/expense/initial-values`,
            {
                headers: {
                    authorization: "Bearer" + " " + user.token,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        setExpenseData(response.data.data);
    };

    const getError = (res) => { };

    const {
        isLoading,
        mutate: getListMutate,
        error,
        data,
        isRefetching,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    useEffect(() => {
        getListMutate();
    }, []);

    const tabName = location?.state?.tabName || "Landlord Info";

    const handleButtonClick = (step) => {
        setActiveStep(step);
    };

    useEffect(() => {
        setActiveStep(tabName);
    }, [tabName]);

    //------- Upload Document -------
    const uploadDocumentFunction = async (data) => {
        const formData = new FormData();
        formData.append("landlordId", landlordData?.id);
        formData.append("type", data.type);
        formData.append("files", data.selectedDoc);
        return await axios.post(
            `${Config.apiUrl}/client/landlord/docs/upload`,
            formData,
            {
                headers: {
                    authorization: "Bearer" + " " + user.token,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
    };

    const onUploadDocSuccess = (data) => {
        setShowUploadModel(false);
        if (data?.data?.isSuccess === true) {
            setDocs(data?.data?.docs);
            toast.success(data?.data?.msg || "Success");
            getListMutate();
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onUploadDocError = (data) => {
        setShowUploadModel(false);
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: isDocLoading, mutate: uploadDocMutate } = useMutation(
        uploadDocumentFunction,
        {
            onSuccess: onUploadDocSuccess,
            onError: onUploadDocError,
        }
    );

    //------- Mark as Paid Model ONLINE -------
    const onlineMarkAsPaidFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/due/paid/with/receipt`, values, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const markAsPaidSuccess = (data) => {
        setIsOnlineMarkPaidOpen(false);
        getListMutate();
        toast.success(data?.data?.msg || "Success");
    };

    const markAsPaidError = (data) => {
        setIsOnlineMarkPaidOpen(false);
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: onlineMarkAsPaidLoading, mutate: onlineMarkAsPaidMutate } =
        useMutation(onlineMarkAsPaidFunction, {
            onSuccess: markAsPaidSuccess,
            onError: markAsPaidError,
        });

    //------- Add Due -------
    const addDueFunction = async (payload) => {
        return await axios.post(`${Config.apiUrl}/expense/add/new`, payload, {
            headers: {
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const { isLoading: addDuesLoading, mutate: addDuesMutate } = useMutation(
        addDueFunction,
        {
            onSettled: () => {
                setIsAddDuesModal(false);
            },
            onSuccess: ({ data }) => {
                getListMutate();
                toast.success(data?.msg || 'Success');
            },
            onError: (error) => {
                toast.error(error?.response?.data?.msg || 'An error occurred');
            },
        }
    );

    //------- Edit Landlord details -------
    const editLandlordFunction = async (values) => {
        const payload = {
            landlordId: landlordData?.id,
            name: values.name,
            mobile: Number(values.mobile),
            email: values.email,
            gender: values.gender,
            dob: values.dob ? moment(values.dob).format("YYYY-MM-DD") : null,
            address: values.address,
            nationality: values.nationality,
            alternateMobile:
                values.alternateMobile === 0 ? "" : values.alternateMobile,
            monthlyIncome: Number(values.monthlyIncome),
            pan: values.pan,
            // bloodGroup: Number(values.bloodGroup),
        };
        return await axios.post(
            `${Config.apiUrl}/landlord/editx`,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${user.token}`,
                },
            }
        );
    };

    const editLandlordSuccess = (data) => {
        getListMutate();
        toast.success(data?.data?.msg || "Success");
    };

    const editLandlordError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: editLandlordLoading, mutate: editLandlordMutate } =
        useMutation(editLandlordFunction, {
            onSuccess: editLandlordSuccess,
            onError: editLandlordError,
        });


    //------- Mark As Paid Expense OFFILE -------
    const offlineMarkPaidFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/expense/mark/paidx`, values, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        });
    };

    const onMarkPaidExpenseSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            getListMutate();
            setIsOfflineMarkPaidOpen(false);
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onMarkPaidExpenseError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: offlineMarkPaidLoading, mutate: offlineMarkPaidMutate } =
        useMutation(offlineMarkPaidFunction, {
            onSuccess: onMarkPaidExpenseSuccess,
            onError: onMarkPaidExpenseError,
        });

    const handleMarkAsPaid = (row) => {
        setSelectedData(row);
        setIsOnlineMarkPaidOpen(false);
        setIsOfflineMarkPaidOpen(false);
        if (row?.canPayOnline) {
            setIsOnlineMarkPaidOpen(true);
        }
        else {
            setIsOfflineMarkPaidOpen(true);
        }
    }

    return (
        <BoxContainer>
            {!error && !isLoading && data && (
                <Wrapper>
                    <CardContainer>
                        <HeaderWrapper>
                            <ProfileWrapper>
                                <AvatarWrapper>
                                    <UserImage
                                        src={Images.Avatar}
                                        alt={`Tenant Profile`}
                                    />
                                </AvatarWrapper>
                                <TenantInfos>
                                    <NameWrapper>
                                        <LandlordName>
                                            {capitalizeFirstLetter(landlordData?.name || "N/A")}
                                        </LandlordName>
                                    </NameWrapper>
                                    <TenantId>
                                        {"#" + landlordData?.mobile || "N/A"}
                                    </TenantId>
                                </TenantInfos>
                            </ProfileWrapper>

                            <ButtonWrapper>
                                <AddDueBtn onClick={() => setIsAddDuesModal(true)}>
                                    Add Dues
                                </AddDueBtn>
                            </ButtonWrapper>
                        </HeaderWrapper>

                        <CardBody>
                            <InfoGrid>
                                <InfoItem>
                                    <InfoLabel>
                                        {/* <FaUser className="w-4 h-4" /> */}
                                        Account Id
                                    </InfoLabel>
                                    <InfoValue>#{landlordData?.mobile || "N/A"}</InfoValue>
                                </InfoItem>

                                <InfoItem>
                                    <InfoLabel>
                                        {/* <FaShieldAlt className="w-4 h-4" /> */}
                                        Security Deposit
                                    </InfoLabel>
                                    <InfoValue>₹{summary?.security}</InfoValue>
                                </InfoItem>

                                <InfoItem>
                                    <InfoLabel>
                                        {/* <MdOutlineTrendingUp className="w-4 h-4" /> */}
                                        Total Payments
                                    </InfoLabel>
                                    <CollectionValue
                                        onClick={() => {
                                            setGoto("totalTransaction");
                                            setActiveStep("Passbook");
                                        }}
                                    >
                                        ₹{summary?.collection || 0}
                                    </CollectionValue>
                                </InfoItem>

                                <InfoItem>
                                    <InfoLabel>
                                        <MdOutlineTrendingDown className="w-4 h-4" />
                                        Total Dues
                                    </InfoLabel>
                                    <DuesValue
                                        onClick={() => {
                                            setGoto("totalDues");
                                            setActiveStep("Passbook");
                                        }}
                                    >
                                        ₹{summary?.totalPending || 0}
                                    </DuesValue>
                                </InfoItem>
                            </InfoGrid>
                        </CardBody>
                    </CardContainer>

                    <SideModal
                        isOpen={isOfflineMarkPaidOpen && !!selectedData}
                        onClose={() => setIsOfflineMarkPaidOpen(false)}
                    >
                        <MarkAsPaidOfflineModal
                            handleClose={() => setIsOfflineMarkPaidOpen(false)}
                            markPaidExpenseLoading={offlineMarkPaidLoading}
                            markPaidExpenseMutate={offlineMarkPaidMutate}
                            selectedData={selectedData}
                            expenseData={expenseData}
                        />
                    </SideModal>

                    <SideModal
                        isOpen={isOnlineMarkPaidOpen && !!selectedData}
                        onClose={() => setIsOnlineMarkPaidOpen(false)}
                    >
                        <MarkAsPaidOnlineModal
                            handleClose={() => setIsOnlineMarkPaidOpen(false)}
                            onlineMarkAsPaidMutate={onlineMarkAsPaidMutate}
                            onlineMarkAsPaidLoading={onlineMarkAsPaidLoading}
                            selectedData={selectedData}
                            selectedExpense={expenseData}
                        />
                    </SideModal>

                    <SideModal
                        isOpen={isAddDuesModal}
                        onClose={() => setIsAddDuesModal(false)}
                    >
                        <AddDuesModal
                            setIsAddDuesModal={setIsAddDuesModal}
                            addDuesMutate={addDuesMutate}
                            addDuesLoading={addDuesLoading}
                            isAddDuesModal={isAddDuesModal}
                            selectedData={propsData}
                            landlordData={landlordData}
                        />
                    </SideModal>

                    <SideModal isOpen={viewDetail} onClose={() => setViewDetail(false)}>
                        <ViewTransDetails
                            setViewDetail={setViewDetail}
                            selectedData={selectedData}
                        />
                    </SideModal>

                    <Card className="mt-4">
                        <FieldWrapper>
                            {/* <div className="mx-auto flex justify-between pb-2 px-4">
                                <div className="flex flex-wrap items-center gap-4 ">
                                    {["Landlord Info", "Properties", "Passbook", "Documents"].map((step) => (
                                        <div key={step} className="flex flex-col items-center">
                                            <button
                                                className={`w-fit px-4 h-8 rounded-full shadow text-sm  ${activeStep === step
                                                    ? "bg-zinc-800 text-zinc-100 font-medium"
                                                    : "bg-gray-200 text-gray-600"
                                                    }`}
                                                onClick={() => handleButtonClick(step)}
                                            >
                                                {step}
                                            </button>
                                        </div>
                                    ))}
                                </div>

                            </div> */}
                            {/* Tabs */}
                            <div className="px-4 border-b">
                                <FloorTabs>
                                    {steps.map((step) => {
                                        const isActive = activeStep === step;

                                        return (
                                            //                             <button
                                            //                                 key={step}
                                            //                                 onClick={() => handleButtonClick(step)}
                                            //                                 className={`relative py-3 text-sm font-medium whitespace-nowrap transition
                                            // ${isActive
                                            //                                         ? "text-zinc-900"
                                            //                                         : "text-zinc-500 hover:text-zinc-700"
                                            //                                     }`}
                                            //                             >
                                            //                                 {step}

                                            //                                 {isActive && (
                                            //                                     <span className="absolute left-0 bottom-0 w-full h-0.5 bg-zinc-900 rounded-full" />
                                            //                                 )}
                                            //                             </button>
                                            <button
                                                key={step}
                                                onClick={() => handleButtonClick(step)}
                                                className={`relative px-1 py-3 text-sm whitespace-nowrap transition-colors duration-200
                          ${isActive
                                                        ? "text-zinc-900 font-semibold"
                                                        : "text-zinc-500 font-normal hover:text-zinc-700"
                                                    }
                        `}
                                            >
                                                {step}

                                                {isActive && (
                                                    <span className="absolute left-0 bottom-0 w-full h-[2px] bg-zinc-900 rounded-full transition-all duration-200" />
                                                )}
                                            </button>
                                        );
                                    })}
                                </FloorTabs>
                            </div>


                            <div className="flex flex-wrap md:flex-nowrap gap-6 px-4 py-4 overflow-y-auto">
                                <div className="w-full">
                                    {activeStep === "Landlord Info" && (
                                        <>
                                            <PersonalDetails
                                                landlordData={landlordData}
                                                editDetailMutate={editLandlordMutate}
                                                isDetailLoading={editLandlordLoading}
                                                setSelectedData={setSelectedData}
                                                selectedData={selectedData}
                                            />
                                        </>
                                    )}

                                    {activeStep === "Passbook" && (
                                        <Passbook
                                            transData={transData}
                                            pendingData={pendingData}
                                            summary={summary}
                                            setSelectedData={setSelectedData}
                                            handleMarkAsPaid={(row) => handleMarkAsPaid(row)}
                                            setViewDetail={setViewDetail}
                                        />
                                    )}

                                    {activeStep === "Properties" && (
                                        <Properties
                                            propsData={propsData}
                                            getListMutate={getListMutate}
                                        />
                                    )}

                                    {activeStep === "Documents" && (
                                        <Documents
                                            docs={landlordData?.docs}
                                            setShowUploadModel={setShowUploadModel}
                                            showUploadModel={showUploadModel}
                                            uploadDocMutate={uploadDocMutate}
                                            isDocLoading={isDocLoading}
                                        />
                                    )}
                                </div>
                            </div>
                        </FieldWrapper>
                    </Card>




                </Wrapper>
            )}
            {(isLoading || isRefetching) && <TenantDetailsLoading />}
        </BoxContainer>
    );
};

const FieldWrapper = tw.div`w-full`;
const Wrapper = tw.div`px-1`;
const Card = tw.div`p-3 rounded-lg bg-white shadow-md `;
const CardContainer = tw.div`bg-white rounded-lg shadow-sm border border-gray-200/60 overflow-hidden`;
const CardHeader = tw.div`px-6 py-5 border-b border-gray-100`;
const HeaderWrapper = tw.div`flex items-center justify-between gap-6 p-5 border-b border-gray-100`;
const ProfileWrapper = tw.div`flex items-center gap-4 z-index`;
const AvatarWrapper = tw.div`flex items-end w-12 h-12`;
const UserImage = tw.img`w-12 h-12 rounded-full shadow-lg`;
const TenantInfos = tw.div`flex-1 min-w-0`;
const NameWrapper = tw.div`flex items-center gap-3`;
const LandlordName = tw.h2`text-md font-semibold text-gray-900 truncate`;
const TenantId = tw.p`text-sm text-gray-500 truncate`;
const ButtonWrapper = tw.div`flex flex-col sm:flex-row gap-3 sm:justify-end`;
const CardBody = tw.div`p-5`;
const InfoGrid = tw.div`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6`;
const InfoItem = tw.div``;
const InfoLabel = tw.div`flex items-center gap-2 text-gray-500 text-sm`;
const InfoValue = tw.p`text-base font-semibold text-gray-900`;
const CollectionValue = tw(
    InfoValue
)`text-emerald-600 cursor-pointer hover:text-emerald-700 transition-colors`;
const DuesValue = tw(
    InfoValue
)`text-red-500 cursor-pointer hover:text-red-600 transition-colors`;
const AddDueBtn = tw.button`
  bg-primary-color text-white
  hover:bg-hover-color
  px-6 py-2.5 rounded-md text-sm font-medium
`;

export default Details;
